import getSupportedLanguage from "$routes/_lib/get-supported-language";
import { USER_LANGUAGE_CODES } from "$routes/_lib/i18n-constants";

// TODO: this default language could be set on a territory basis using config
export const DEFAULT_LANGUAGE = USER_LANGUAGE_CODES.ENGLISH;

export function getBrowserLanguage() {
  return (
    getSupportedLanguage(window.navigator.languages) ||
    getSupportedLanguage(window.navigator.language) ||
    DEFAULT_LANGUAGE
  );
}
